<template>
  <div v-if="$parent.rerender && aboutProject.project" style="padding-top: 0px">
    <div class="wraper">
      <div class="container-fluid mycontainer-fluid page-content">
        <div class="row">
          <div class="col-xs-12">
            <div class="container-flex container-flex-card row myrow">
              <div
                class="container-col col-xs-12 col-sm-12 col-md-6 col-lg-7 mycol"
              >
                <div
                  v-if="
                    currentUser.ACTIVE_ROLE_CODE === 'lizing' &&
                      $parent.getProgramCode() !== 'lizing_ships' &&
                      aboutProject &&
                      aboutProject.project.UF_COMPANY_ID === 0
                  "
                  class="container-stl container-stl-card"
                >
                  <div class="container-stl-title">Выбор организации</div>
                  <div style="padding: 10px 15px;">
                    <div class="alert alert-danger" v-for="err in lizingErrors">
                      {{ err.TEXT }}
                    </div>
                    <div class="form-group">
                      <label>Название организации</label>
                      <input
                        v-model="lizing.UF_NAME"
                        class="form-control"
                        placeholder="Название оганизации"
                      />
                    </div>
                    <div class="form-group">
                      <label>ОГРН</label>
                      <input
                        v-model="lizing.UF_OGRN"
                        class="form-control"
                        placeholder="ОГРН организации"
                      />
                    </div>
                    <button
                      type="button"
                      @click="addOrgLizing"
                      class="btn btn-default"
                    >
                      Добавить организацию
                    </button>
                  </div>
                </div>

                <!--      Заявка          -->
                <div class="container-stl container-stl-card">
                  <div class="container-stl-title">Заявка</div>
                  <table class="container-stl-table">
                    <tbody>
                      <tr>
                        <td class="td-name">Номер заявки</td>
                        <td class="text-right">
                          {{ aboutProject.REQUEST_INFO.UF_NUMBER }}
                        </td>
                      </tr>
                      <tr>
                        <td class="td-name">Статус заявки</td>
                        <td class="text-right" v-if="aboutProject.REQUEST_INFO.STATUS">
                          {{ aboutProject.REQUEST_INFO.STATUS.UF_STATUS_NAME }}
                          <a
                            v-if="
                              aboutProject.REQUEST_INFO.STATUS
                                .IS_CHANGE_STATUS === 1
                            "
                            @click="showChangeStatusDialog = true"
                            title="Изменение статуса"
                            class="icon-item icon-edit-link"
                          />
                          <a
                            v-if="
                              aboutProject.REQUEST_INFO.STATUS
                                .IS_VIEW_HISTORY_STATUS === 1
                            "
                            @click="loadStatusHistory()"
                            title="История изменения статуса"
                            class="icon-item status-history"
                          />

                          <span
                            v-if="
                              aboutProject.REQUEST_INFO.IS_VIEW_RETURN_CE === 1
                            "
                            @click="openByReturnCE()"
                            title="Откат заявки с ПэКС на КЭ"
                            style="color:#b73232; border-bottom: 1px dashed; cursor: pointer;"
                            >Вернуть на КЭ</span
                          >
                        </td>
                      </tr>
                      <tr v-if="aboutProject.REQUEST_INFO.STATUS">
                        <td class="td-name">Дата начала действия статуса</td>
                        <td class="text-right">
                          {{
                            aboutProject.REQUEST_INFO.STATUS.DATE_START_STATUS
                          }}
                        </td>
                      </tr>
                      <tr
                        v-if="
                          aboutProject.REQUEST_INFO.IS_VIEW_DEDLAIN_PKD == 1
                        "
                      >
                        <td class="td-name">
                          Дедлайн подготовки документов для комплексной
                          экспертизы <br />(срок включает подготовку, входную экспертизу и возможные доработки документов)
                        </td>
                        <td class="text-right">
                          {{ aboutProject.REQUEST_INFO.TEXT_DEDLAIN }}
                        </td>
                      </tr>
                      <tr>
                        <td class="td-name">
                          Дата последнего изменения резюме
                        </td>
                        <td class="text-right">
                          {{ aboutProject.UF_DATE_LAST_CHANGE }}
                        </td>
                      </tr>
                      <tr
                        v-if="
                          aboutProject.REQUEST_INFO.IS_VIEW_PAUSE_PROJECT == 1
                        "
                      >
                        <td class="td-name">
                          Пауза на КЭ
                          <a
                            v-if="
                              aboutProject.REQUEST_INFO.IS_EDIT_PAUSE_PROJECT ==
                                1
                            "
                            @click="makePause()"
                            class="icon-item add-butt"
                          />
                        </td>
                        <td class="text-right">
                          {{ aboutProject.REQUEST_INFO.TEXT_PAUSE }}
                          <a
                            v-if="
                              aboutProject.REQUEST_INFO.IS_VIEW_PAUSE_HISTORY ==
                                1
                            "
                            @click="loadPauseHistory()"
                            title="Паузы на КЭ"
                            class="icon-item status-history"
                          />
                        </td>
                      </tr>

                      <tr
                        v-if="
                          aboutProject.REQUEST_INFO.IS_VIEW_NEED_CORPORATE == 1
                        "
                      >
                        <td class="td-name">
                          Необходимость корп. одобрения
                        </td>
                        <td class="text-right">
                          {{
                            aboutProject.SETTING_TABLE.data
                              .UF_IS_NEED_CORPORATE == 1
                              ? "Да"
                              : "Нет"
                          }}
                          <a
                            v-if="
                              aboutProject.REQUEST_INFO
                                .IS_EDIT_NEED_CORPORATE == 1
                            "
                            @click="
                              showEditFieldSettingBoolProject(
                                aboutProject.SETTING_TABLE.data
                                  .UF_IS_NEED_CORPORATE,
                                'UF_IS_NEED_CORPORATE',
                                'Необходимость корп. одобрения'
                              )
                            "
                            class="icon-item icon-edit-link"
                          />
                        </td>
                      </tr>

                      <tr
                        v-if="
                          aboutProject.REQUEST_INFO.IS_VIEW_CONSIDER_NS == 1
                        "
                      >
                        <td class="td-name">
                          Необходимость рассмотрения на НС
                        </td>
                        <td class="text-right">
                          {{
                            aboutProject.SETTING_TABLE.data
                              .UF_IS_NEED_CONSIDER_NS == 1
                              ? "Да"
                              : "Нет"
                          }}
                          <a
                            v-if="
                              aboutProject.REQUEST_INFO.IS_EDIT_CONSIDER_NS == 1
                            "
                            @click="
                              showEditFieldSettingBoolProject(
                                aboutProject.SETTING_TABLE.data
                                  .UF_IS_NEED_CONSIDER_NS,
                                'UF_IS_NEED_CONSIDER_NS',
                                'Необходимость рассмотрения на НС'
                              )
                            "
                            class="icon-item icon-edit-link"
                          />
                        </td>
                      </tr>

                      <tr
                        v-if="
                          aboutProject.REQUEST_INFO.IS_VIEW_CLEAR_CACHE === 1
                        "
                      >
                        <td class="td-name"></td>
                        <td class="text-right">
                          <a
                            @click="clearCache()"
                            title="Сбросить кэш проекта"
                            class="butt-stl butt-stl-midlle butt-black"
                            style="width: 120px; margin-left: auto;"
                          >
                            Сбросить кэш</a
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!--      /Заявка          -->
                <!--      Организация          -->
                <div class="container-stl container-stl-card" v-if="aboutProject.ORG_INFO">
                  <div class="container-stl-title">
                    Организация {{ aboutProject.ORG_INFO.UF_NAME }}
                  </div>
                  <table class="container-stl-table">
                    <tbody>
                      <tr>
                        <td class="td-name">ОГРН</td>
                        <td class="text-right">
                          {{ aboutProject.ORG_INFO.UF_OGRN }}
                        </td>
                      </tr>
                      <tr>
                        <td class="td-name">ИНН / КПП</td>
                        <td class="text-right">
                          <template v-if="aboutProject.ORG_INFO.UF_INN_KPP">
                            {{ aboutProject.ORG_INFO.UF_INN_KPP }}
                          </template>
                          <template v-else>
                            {{ aboutProject.ORG_INFO.UF_INN }} /
                            {{ aboutProject.ORG_INFO.UF_KPP }}
                          </template>
                        </td>
                      </tr>
                      <tr>
                        <td class="td-name">Дата гос. регистрации</td>
                        <td class="text-right">
                          {{ aboutProject.ORG_INFO.UF_DATE_REGISTER }}
                        </td>
                      </tr>

                      <tr>
                        <td class="td-name">Руководитель</td>
                        <td class="text-right">
                          {{ aboutProject.ORG_INFO.UF_DIRECTOR }}
                        </td>
                      </tr>
                      <tr>
                        <td class="td-name">
                          Web сайт
                          <a
                            v-if="
                              !aboutProject.ORG_INFO.UF_WEB_SITE &&
                                !!aboutProject.ORG_INFO.UF_IS_WEB_SITE_EDIT
                            "
                            @click="makeSiteDialog"
                            class="icon-item add-butt"
                          />
                        </td>
                        <td class="text-right">
                          <a
                            v-if="
                              !!aboutProject.ORG_INFO.UF_WEB_SITE &&
                                !isShowChangeWebSite
                            "
                            :href="
                              'http://' + aboutProject.ORG_INFO.UF_WEB_SITE
                            "
                            target="_blank"
                          >
                            {{ aboutProject.ORG_INFO.UF_WEB_SITE }}
                          </a>
                          <a
                            v-if="
                              !!aboutProject.ORG_INFO.UF_WEB_SITE &&
                                !!aboutProject.ORG_INFO.UF_IS_WEB_SITE_EDIT
                            "
                            @click="makeSiteDialog"
                            class="icon-item icon-edit-link"
                          />
                        </td>
                      </tr>
                      <tr
                        v-for="(address, index) in aboutProject.ORG_INFO.ADRESS"
                        :key="index"
                      >
                        <td class="td-name">
                          {{
                            aboutProject.ORG_INFO.ADRESS_ALL_TYPE[
                              address.UF_TYPE_ADDR_ID
                            ]
                              ? aboutProject.ORG_INFO.ADRESS_ALL_TYPE[
                                  address.UF_TYPE_ADDR_ID
                                ].NAME
                              : ""
                          }}
                        </td>
                        <td class="text-right">
                          {{ address.ADDRESS_STRING }}
                          <a
                            v-if="
                              aboutProject.ORG_INFO.UF_IS_ADDRESS_EDIT === 1 &&
                                address.ADDRESS_TYPE !== 'juric_address'
                            "
                            @click="editAddress(index)"
                            class="icon-item icon-edit-link"
                          />
                        </td>
                      </tr>
                      <tr
                        v-for="(address, index) in aboutProject.ORG_INFO
                          .UF_IS_ADDRESS_EDIT === 1
                          ? aboutProject.ORG_INFO.ADRESS_TYPE
                          : []"
                        :key="index"
                      >
                        <td
                          class="td-name"
                          :style="address.isOneSet == 1 ? '' : 'color: red'"
                        >
                          {{ address.NAME }}
                          <a
                            v-if="
                              Object.entries(aboutProject.ORG_INFO.ADRESS_TYPE)
                                .length > 0 &&
                                aboutProject.ORG_INFO.UF_IS_ADDRESS_EDIT === 1
                            "
                            @click="makeAddress(address.ID)"
                            class="icon-item"
                            :class="
                              address.isOneSet == 1
                                ? 'add-butt'
                                : 'add-butt-red'
                            "
                          />
                        </td>
                        <td class="text-right"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!--      /Организация          -->
                <!--   Контактные лица по заявке          -->
                <div class="container-stl container-stl-card">
                  <div class="container-stl-title uf_name">
                    Контактные лица по заявке
                    <span class="h-t-status-info info-holder-container">
                      <VDropdown
                        tag="span"
                        trigger="click"
                        placement="bottom"
                        popperClass="custom-popper"
                        :distance="25"
                        style="display: inline"
                      >
                        <a class="info-holder-icon" />
                        <template #popper>
                          <span class="custom-popper-content">
                            Контактные лица подтягиваются автоматически из
                            мастер-аккаунта организации из списка сотрудников с
                            активной учетной записью. Ссылка для перехода к
                            <a
                              href="https://spravka.frprf.ru/MA"
                              target="_blank"
                              style="color: #FFFFFF; text-decoration: underline"
                            >
                              инструкции</a
                            >.
                          </span>
                        </template>
                      </VDropdown>
                    </span>
                    <a
                      @click="isShowContacts = !isShowContacts"
                      class="icon-item icon-open-link"
                      :class="{
                        collapse: !isShowContacts
                      }"
                    />
                  </div>
                  <table v-if="isShowContacts" class="container-stl-table">
                    <thead>
                      <tr>
                        <th>Организация</th>
                        <th>ФИО</th>
                        <th>Должность</th>
                        <th
                          v-if="
                            aboutProject.ORG_INFO.CONTACTS.IS_VIEW_ADMIN !== 0
                          "
                        >
                          Телефон
                        </th>
                        <th
                          v-if="
                            aboutProject.ORG_INFO.CONTACTS.IS_VIEW_ADMIN !== 0
                          "
                        >
                          EMAIL
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(contact, index) in aboutProject.ORG_INFO
                          .CONTACTS.LIST"
                        :key="index"
                      >
                        <td class="td-name">{{ contact.ORG_NAME }}</td>
                        <td>
                          <template
                            v-if="
                              aboutProject.ORG_INFO.CONTACTS
                                .IS_VIEW_LINK_CONTACT === 1 && contact.LINK_USER
                            "
                          >
                            <a :href="contact.LINK_USER" target="_blank">{{
                              contact.FIO
                            }}</a>
                          </template>
                          <template v-else>{{ contact.FIO }}</template>
                        </td>
                        <td>{{ contact.POSITION }}</td>
                        <td
                          v-if="
                            aboutProject.ORG_INFO.CONTACTS.IS_VIEW_ADMIN !== 0
                          "
                        >
                          {{ contact.PHONE }}
                          <template v-if="contact.DOP_PHONE">(доб. {{ contact.DOP_PHONE }})</template>
                        </td>
                        <td
                          v-if="
                            aboutProject.ORG_INFO.CONTACTS.IS_VIEW_ADMIN !== 0
                          "
                        >
                          {{ contact.EMAIL }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!--      /Контактные лица по заявке          -->
                <div class="row">
                  <div class="col-xs-12 col-md-12 col-lg-6 stl-mb-20">
                    <!--      Связанные организации          -->
                    <div
                      v-if="aboutProject.ORG_GROUP_INFO.IS_VIEW_AREA === 1"
                      class="container-stl container-stl-card"
                    >
                      <div class="container-stl-title">
                        Связанные организации
                        <a
                          @click="isShowAssociatedOrgs = !isShowAssociatedOrgs"
                          class="icon-item icon-open-link"
                          :class="{ collapse: !isShowAssociatedOrgs }"
                        />
                      </div>
                      <table
                        v-if="isShowAssociatedOrgs"
                        class="container-stl-table"
                      >
                        <thead>
                          <tr>
                            <th>Название организации</th>
                            <th>Роль в проекте</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in aboutProject.ORG_GROUP_INFO
                              .ORG_LIST"
                            :key="index"
                          >
                            <td class="td-name">
                              <a :href="item.LINK" target="_blank">
                                {{ item.UF_NAME }}
                              </a>
                            </td>
                            <td>{{ item.UF_ROLE }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <!--      /Связанные организации          -->
                  </div>
                  <div class="col-xs-12 col-md-12 col-lg-6 stl-mb-20">
                    <!--      Дополнительная информация          -->
                    <div
                      v-if="aboutProject.PROJECT_DOP_INFO.IS_VIEW_AREA === 1"
                      class="container-stl container-stl-card"
                    >
                      <div class="container-stl-title">
                        Дополнительная информация
                      </div>
                      <div class="container-stl-body">
                        <div class="df-ac df-js-b">
                          <div class="stl-mr-10">Перейти к странице</div>
                          <router-link
                            :to="{
                              name: 'AddInfo',
                              params: { id: $route.params.id }
                            }"
                            class="butt-stl butt-blue"
                          >
                            ДОП. ИНФОРМАЦИЯ
                          </router-link>
                        </div>
                      </div>
                    </div>
                    <!--  /Дополнительная информация   -->
                  </div>
                </div>
              </div>
              <div
                class="container-col col-xs-12 col-sm-12 col-md-6 col-lg-5 mycol"
              >
                <div
                  v-if="
                    aboutProject.PROJECT_NOTIFICATIONS.COUNT_AREA === 2 &&
                      aboutProject.PROJECT_NOTIFICATIONS.IS_VIEW_AREA === 1
                  "
                  class="row"
                >
                  <div class="col-xs-12 col-md-6 col-lg-6 stl-mb-20">
                    <!--      Уведомления          -->
                    <div class="container-stl container-stl-card">
                      <div class="container-stl-title">Уведомления</div>
                      <div class="container-stl-body">
                        <div class="df-ac">
                          <router-link
                            :to="{
                              name: 'ProjectNotifications',
                              params: { id: $route.params.id }
                            }"
                            class="butt-blue butt-stl stl-mr-10"
                          >
                            {{
                              aboutProject.PROJECT_NOTIFICATIONS.CHAT_AREA
                                .TEXT_BUTTON
                            }}
                          </router-link>
                          <span class="card-info-text">
                            <i class="icon-item icon-info-dis"></i>
                            {{
                              aboutProject.PROJECT_NOTIFICATIONS.CHAT_AREA
                                .TEXT_AREA
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <!--      /Уведомления          -->
                  </div>
                  <div class="col-xs-12 col-md-6 col-lg-6 stl-mb-20">
                    <!--      Запросы          -->
                    <div
                      v-if="aboutProject.PROJECT_NOTIFICATIONS.COUNT_AREA === 2"
                      class="container-stl container-stl-card"
                    >
                      <div class="container-stl-title">
                        <a
                          v-show="false"
                          :href="getLinkRequestCreate()"
                          class="link-add-row"
                        title="Создать новый запрос"></a>

                        Внутренние согласования
                      </div>
                      <div class="container-stl-body">
                        <div class="df-ac">
                          <a
                            v-if="aboutProject.REQUEST_INFO"
                            :href="getLinkRequest()"
                            class="butt-blue butt-stl stl-mr-10"
                          >
                            {{
                              aboutProject.PROJECT_NOTIFICATIONS.EVENT_AREA
                                .TEXT_BUTTON
                            }}</a
                          >

                          <!--<router-link
                            :to="{ name: 'Requests' }"
                            class="butt-blue butt-stl stl-mr-10"
                          >
                            {{
                              aboutProject.PROJECT_NOTIFICATIONS
                                .EVENT_AREA.TEXT_BUTTON
                            }}
                          </router-link>-->
                          <span class="card-info-text">
                            <i class="icon-item icon-info-dis"></i>
                            {{
                              aboutProject.PROJECT_NOTIFICATIONS.EVENT_AREA
                                .TEXT_AREA
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <!--      /Запросы          -->
                  </div>
                </div>
                <!--      Уведомления          -->
                <div
                  v-else-if="
                    aboutProject.PROJECT_NOTIFICATIONS.IS_VIEW_AREA === 1
                  "
                  class="container-stl container-stl-card"
                >
                  <div class="container-stl-title">Уведомления</div>
                  <div class="container-stl-body">
                    <div class="df-ac">
                      <router-link
                        :to="{
                          name: 'ProjectNotifications',
                          params: { id: $route.params.id }
                        }"
                        class="butt-blue butt-stl stl-mr-10"
                      >
                        {{
                          aboutProject.PROJECT_NOTIFICATIONS.CHAT_AREA
                            .TEXT_BUTTON
                        }}
                      </router-link>
                      <span class="card-info-text">
                        <i class="icon-item icon-info-dis"></i>
                        {{
                          aboutProject.PROJECT_NOTIFICATIONS.CHAT_AREA.TEXT_AREA
                        }}
                      </span>
                    </div>
                  </div>
                </div>
                <!--      /Уведомления          -->
                <!--      Информация о проекте          -->
                <div class="container-stl container-stl-card">
                  <div class="container-stl-title">Информация о проекте</div>
                  <div class="container-stl-body">
                    <div class="df-ac df-js-b w-1770-fw">
                      <table class="light-table">
                        <tbody>
                          <tr>
                            <td class="stl-fw-bold">Название проекта:</td>
                            <td>
                              {{ aboutProject.PROJECT_MAIN_INFO.UF_NAME }}
                            </td>
                          </tr>
                          <tr>
                            <td class="stl-fw-bold">Программа:</td>
                            <td>
                              {{
                                aboutProject.PROJECT_MAIN_INFO
                                  .UF_SUPPORT_PROG_NAME
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <router-link
                                v-if="
                                  aboutProject.PROJECT_MAIN_INFO
                                    .IS_VIEW_DOC_ES === 1
                                "
                                :to="{
                                  name: 'ProjectDocuments',
                                  params: { id: $route.params.id }
                                }"
                                class="stl-link-blue stl-fw-bold"
                              >
                                Документы проекта
                              </router-link>
                            </td>
                            <td>
                              <a
                                v-if="
                                  aboutProject.PROJECT_MAIN_INFO
                                    .IS_VIEW_DOC_ES_ARHIVE === 1
                                "
                                @click="getLinkFileArhive"
                                class="butt-stl butt-stl-midlle butt-black"
                                style="width: 217px;"
                              >
                                Скачать одним архивом
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <router-link
                                v-if="
                                  aboutProject.PROJECT_MAIN_INFO
                                    .IS_VIEW_DOC_DZ === 1
                                "
                                :to="{
                                  name: 'AddDZ',
                                  params: { id: $route.params.id }
                                }"
                                class="stl-link-blue stl-fw-bold"
                              >
                                Оформление ДЗ
                              </router-link>
                            </td>
                            <td>
                              <a
                                v-if="
                                  aboutProject.PROJECT_MAIN_INFO
                                    .IS_VIEW_DOC_DZ_ARHIVE === 1
                                "
                                @click="getLinkFileArhiveDZ"
                                class="butt-stl butt-stl-midlle butt-black"
                                style="width: 217px;"
                              >
                                Скачать одним архивом
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div class="card-butt">
                        <a
                          @click="getLinkPdfUrl"
                          class="butt-stl butt-black butt-w-244"
                        >
                          Скачать резюме проекта
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <!--      /Информация о проекте          -->
                <!--      Продукция проекта (дубликат в режиме чтения)       -->
                <div
                  v-if="
                    project &&
                      project.UF_SETTING &&
                      project.UF_SETTING.IS_VIEW_NEW_INFORMATION_PROJECT &&
                      project.PROJECT_OKPD_PRODUCTS &&
                      project.PROJECT_OKPD_PRODUCTS.items &&
                      project.PROJECT_OKPD_PRODUCTS.items.length > 0
                  "
                  class="container-stl container-stl-card"
                >
                  <div class="container-stl-title">Продукция проекта</div>
                  <div class="container-stl-body">
                    <ProjectOkpdProducts :readonly="true"></ProjectOkpdProducts>
                  </div>
                </div>
                <!--      /Продукция проекта (дубликат в режиме чтения)     -->
                <!--      История вынесения пректа на ЭС          -->
                <div
                  v-if="aboutProject.PROJECT_ES_INFO.IS_VIEW_AREA === 1"
                  class="container-stl container-stl-card"
                >
                  <div class="container-stl-title df-ac">
                    История вынесения проекта на совет
                    <a
                      @click="isShowHistoryES = !isShowHistoryES"
                      class="icon-item icon-open-link"
                      :class="{ collapse: !isShowHistoryES }"
                    />
                  </div>
                  <div class="container-stl-body">
                    <div class="df-ac df-js-b">
                      <table v-if="isShowHistoryES" class="container-stl-table">
                        <thead>
                          <th>№ совета</th>
                          <th>Дата совета</th>
                          <th>Тип совета</th>
                          <th>Дата вынесения проекта на совет</th>
                          <th>Комментарий</th>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in aboutProject.PROJECT_ES_INFO
                              .LIST"
                            :key="index"
                          >
                            <td>
                              <router-link
                                v-if="item.IS_VIEW_LINK === 1"
                                :to="{
                                  name: 'Questions',
                                  params: {
                                    id: item.SOVET_ID,
                                    projectId: item.ID
                                  }
                                }"
                                class="stl-link-blue stl-fw-bold"
                              >
                                {{ item.NUMBER_ES }}
                              </router-link>
                              <template v-else> {{ item.NUMBER_ES }}</template>
                            </td>
                            <td>{{ item.DATE_ES }}</td>
                            <td>{{ item.TYPE_ES }}</td>
                            <td>{{ item.DATE_ADD_ES }}</td>
                            <td>{{ item.COMMENT }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <!--      /История вынесения пректа на ЭС          -->
                <!--      Приложения          -->
                <div
                  v-if="
                    aboutProject.PROJECT_DZ_INFO.IS_VIEW_AREA_DZ_APPLICATION ===
                      1
                  "
                  class="container-stl container-stl-card"
                >
                  <div class="container-stl-title df-ac">
                    Приложения
                    <a
                      @click="isShowApplication = !isShowApplication"
                      class="icon-item icon-open-link"
                      :class="{ collapse: !isShowApplication }"
                    />
                  </div>
                  <table v-if="isShowApplication" class="container-stl-table">
                    <tbody>
                      <tr>
                        <td class="td-name stl-fw-bold">
                          Техническое задание (список закупаемого)
                        </td>
                        <td class="text-right">
                          <router-link
                            :to="{
                              name: 'ProjectDocumentsPlan',
                              params: {
                                id: $route.params.id,
                                page: 'purchased-list'
                              }
                            }"
                            class="stl-link-black"
                          >
                            Перейти
                          </router-link>
                          <!--<a
            @click="getPrintTZDocxUrl"
            class="stl-link-black"
            type="button"
          >
            Скачать
          </a>-->
                        </td>
                      </tr>
                      <tr
                        v-if="
                          !['lizing', 'lizing_ships'].includes(
                            $parent.getProgramCode()
                          )
                        "
                      >
                        <td class="td-name stl-fw-bold">
                          Смета расходования средств
                        </td>
                        <td class=" text-right">
                          <a
                            @click.prevent="$emit('set', 'budget', '#target')"
                            :href="
                              '/project/edit/' +
                                $route.params.id +
                                '/budget#target'
                            "
                            class="stl-link-black"
                          >
                            Перейти
                          </a>
                          <!--<a
            @click="getPrintBudgetDocxUrl"
            class="stl-link-black"
            type="button"
          >
            Перейти
          </a>-->
                        </td>
                      </tr>
                      <tr>
                        <td class="td-name stl-fw-bold">
                          Календарный план проекта
                        </td>
                        <td class=" text-right">
                          <router-link
                            :to="{
                              name: 'ProjectDocumentsPlan',
                              params: {
                                id: $route.params.id,
                                page: 'tasks-targets'
                              }
                            }"
                            class="stl-link-black"
                          >
                            Перейти
                          </router-link>
                          <!--<a
            @click="getPrintPlanDocxUrl"
            class="stl-link-black"
            type="button"
          >
            Скачать
          </a>-->
                        </td>
                      </tr>
                      <tr>
                        <td class="td-name stl-fw-bold">Целевые показатели</td>
                        <td class=" text-right">
                          <a
                            @click.prevent="$emit('set', 'planned-indicators')"
                            :href="
                              '/project/edit/' +
                                $route.params.id +
                                '/planned-indicators'
                            "
                            class="stl-link-black"
                          >
                            Перейти
                          </a>
                          <!--<a
            @click="getPrintIndicatorsDocxUrl"
            class="stl-link-black"
            type="button"
          >
            Скачать
          </a>-->
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!--      /Приложения          -->
                <div class="row">
                  <div
                    class="col-xs-12 col-md-12 col-lg-6 stl-mb-20"
                    v-if="
                      aboutProject.PROJECT_MAIN_INFO
                        .MANAGER_ITAP_INFO_EXPERTISE_VIEW === 1
                    "
                  >
                    <!--      Экспертизы проекта          -->
                    <div class="container-stl container-stl-card">
                      <div class="container-stl-title">
                        Экспертизы проекта
                      </div>
                      <div class="container-stl-body">
                        <div class="df-ac df-js-b">
                          <router-link
                            :to="{
                              name: 'ExpertStatus',
                              params: { id: this.$route.params.id }
                            }"
                            class="butt-stl butt-blue"
                          >
                            Реестр экспертиз
                          </router-link>
                        </div>
                      </div>
                    </div>
                    <!--      /Экспертизы проекта          -->
                  </div>
                  <div class="col-xs-12 col-md-12 col-lg-6 stl-mb-20">
                    <!--      Этапы подачи заявки          -->
                    <div
                      v-if="
                        aboutProject.PROJECT_MAIN_INFO
                          .IS_VIEW_MANAGER_ITAP_INFO === 1
                      "
                      class="container-stl container-stl-card"
                    >
                      <div class="container-stl-title">
                        Этапы подачи заявки
                      </div>
                      <div class="container-stl-body">
                        <div class="df-ac df-js-b">
                          <div class="stl-mr-10">Сценарий заявки</div>
                          <button
                            type="button"
                            @click="handleToRequest"
                            class="butt-stl butt-blue"
                          >
                            Перейти к заявке
                          </button>
                        </div>
                      </div>
                    </div>
                    <!--      /Этапы подачи заявки          -->
                  </div>
                </div>
                <!--      Этапы подачи заявки          -->
                <div
                  v-if="
                    aboutProject.PROJECT_MAIN_INFO.IS_VIEW_USER_ITAP_INFO == 1
                  "
                  class="container-stl container-stl-card"
                >
                  <div class="container-stl-title df-ac">
                    Этапы подачи заявки
                  </div>
                  <div class="container-stl-body">
                    <div
                      v-if="
                        aboutProject.PROJECT_MAIN_INFO.USER_ITAP_INFO
                          .IS_VIEW_HELP === 1
                      "
                      style="color: red"
                      v-html="
                        aboutProject.PROJECT_MAIN_INFO.USER_ITAP_INFO.HELP_TEXT
                      "
                    />
                    <div v-else class="df-ac df-js-b">
                      <table class="light-table">
                        <tbody>
                          <tr>
                            <td>
                              <button
                                type="button"
                                @click="handleToRequest"
                                :disabled="
                                  aboutProject.PROJECT_MAIN_INFO.USER_ITAP_INFO
                                    .IS_BLOCK_BUTTON === 1
                                "
                                :class="
                                  aboutProject.PROJECT_MAIN_INFO.USER_ITAP_INFO
                                    .IS_BLOCK_BUTTON === 1
                                    ? 'butt-stl butt-blue butt-black-dis butt-w-244'
                                    : 'butt-stl butt-stl2 butt-blue butt-w-244'
                                "
                              >
                                Перейти к заявке
                              </button>
                            </td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <!--      /Этапы подачи заявки          -->

                <!--      Акцепты          -->
                <div
                  class="container-stl container-stl-card"
                  v-if="
                    isAccept ||
                      aboutProject.USER_RULES.isViewAcceptPlan == 1 ||
                      isViewAcceptPlan
                  "
                >
                  <div class="container-stl-title">
                    Акцепты
                    <a
                      @click="isShowAcceptInfo = !isShowAcceptInfo"
                      class="icon-item icon-open-link"
                      :class="{ collapse: !isShowAcceptInfo }"
                    />
                  </div>
                  <div class="container-stl-body" v-if="isShowAcceptInfo">
                    <div class="acceptance-control-wrapper">
                      <!-- Акцептование резюме -->
                      <template v-if="isAccept === 1">
                        <button
                          v-show="aboutProject.project.UF_IS_ACCEPT_PROJECT !== 1"
                          class="butt-stl butt-blue butt-stl--acceptance"
                          type="button"
                          @click="changeAcceptProject(1)"
                        >
                          Акцептовать резюме
                        </button>
                        <button
                          v-show="aboutProject.project.UF_IS_ACCEPT_PROJECT === 1"
                          class="butt-stl butt-red butt-stl--acceptance"
                          type="button"
                          @click="changeAcceptProject(0)"
                        >
                          Резюме акцептовано
                        </button>
                      </template>

                      <!-- Акцептовать список закупаемого -->
                      <template
                        v-if="
                          isViewAcceptPlan ||
                            aboutProject.USER_RULES.isViewAcceptPlan == 1
                        "
                      >
                        <button
                          v-if="
                            aboutProject.project.UF_SETTING &&
                              aboutProject.project.UF_SETTING.IS_EQUIPMENT_ACCEPT !==
                                1
                          "
                          class="butt-stl butt-blue butt-stl--acceptance"
                          type="button"
                          @click="changeAcceptEquipment(1)"
                        >
                          Акцептовать <br />
                          список закупаемого
                        </button>
                        <button
                          v-else
                          class="butt-stl butt-red butt-stl--acceptance"
                          type="button"
                          @click="changeAcceptEquipment(0)"
                        >
                          Список закупаемого<br />акцептован
                        </button>
                      </template>

                      <!-- Акцептовать КП, задачи, цели и продукцию проекта -->
                      <template
                        v-if="
                          isViewAcceptPlan ||
                            aboutProject.USER_RULES.isViewAcceptPlan == 1
                        "
                      >
                        <button
                          v-if="aboutProject.project.UF_SETTING.IS_PLAN_ACCEPT !== 1"
                          class="butt-stl butt-blue butt-stl--acceptance"
                          type="button"
                          @click="changeAcceptCalendarPlan(1)"
                        >
                          Акцептовать КП, задачи, цели и<br />
                          продукцию проекта
                        </button>
                        <button
                          v-else
                          class="butt-stl butt-red butt-stl--acceptance"
                          type="button"
                          @click="changeAcceptCalendarPlan(0)"
                        >
                          КП, задачи, цели и <br />продукция проекта акцептованы
                        </button>
                      </template>
                    </div>
                  </div>
                </div>
                <!-- Акцепты -->

                <!--      Контактная информация фонда          -->
                <div class="container-stl container-stl-card">
                  <div class="container-stl-title">
                    Контактная информация фонда
                    <a
                      @click="isShowContactsInfo = !isShowContactsInfo"
                      class="icon-item icon-open-link"
                      :class="{ collapse: !isShowContactsInfo }"
                    />
                    <a
                      v-if="
                        aboutProject &&
                          aboutProject.CONTACT_FOND_INFO &&
                          aboutProject.CONTACT_FOND_INFO.IS_EDIT_INFO === 1
                      "
                      @click="showContactInformationModal = true"
                      type="button"
                      class="icon-item icon-edit-link"
                    />
                  </div>
                  <table
                    v-if="
                      aboutProject &&
                        aboutProject.CONTACT_FOND_INFO &&
                        isShowContactsInfo
                    "
                    class="container-stl-table"
                  >
                    <tbody>
                      <tr
                        v-for="(item, index) in aboutProject.CONTACT_FOND_INFO
                          .LIST"
                        :key="index"
                      >
                        <td class="td-name">{{ item.LABEL }}</td>

                        <td v-if="item.SET_BY_MANAGER" class="text-right">
                          <span
                            style="color:#b73232; border-bottom: 1px dashed; cursor: pointer;"
                            @click="saveManagerOne(item.FIELD)"
                            >{{ item.VALUE_TEXT }}</span
                          >
                        </td>
                        <td
                          v-else
                          class="text-right"
                          v-html="item.VALUE_TEXT"
                        />
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!--      /Контактная информация фонда          -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--      Изменение статуса модальное окно         -->
      <ChangeStatusDialog v-if="showChangeStatusDialog"></ChangeStatusDialog>
      <!--      /Изменение статуса модальное окно         -->
      <!--      История изменения статуса модальное окно         -->
      <!-- История изменений статуса заявки -->
      <div
        class="modal fade in show"
        v-if="showStatusHistory"
        tabindex="-1"
        role="dialog"
      >
        <form>
          <div
            class="modal-dialog modal-close-active modal-new-style"
            role="document"
          >
            <div
              class="modal-content modal-content-middle modal-content-history"
            >
              <div class="modal-header">
                <button
                  type="button"
                  class="close"
                  @click="showStatusHistory = false"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">История изменений статуса заявки</h4>
                <div class="modal-suptitle">
                  {{ aboutProject.ORG_INFO.UF_NAME }} №
                  {{ aboutProject.REQUEST_INFO.UF_NUMBER }}
                </div>
              </div>
              <div class="modal-body">
                <div
                  class="modal-history-statys"
                  v-for="(item, index) in projectStatusHistory"
                  :key="index"
                >
                  <template v-if="item.IS_VIEW_STATUS == 1">
                    <div class="modal-history-statys__name">
                      {{ getStatusName(item.UF_CURRENT_ST_ID) }}
                    </div>
                    <div class="modal-history-statys__author">
                      {{ item.MANAGER_NAME }}
                      <span>{{ item.UF_START_DATE_ST }}</span>
                    </div>
                  </template>
                  <template v-else>
                    <div class="modal-history-statys__name">
                      Пауза на КЭ
                    </div>
                    <div class="modal-history-statys__author">
                      {{ item.MANAGER_NAME }}
                      <span
                        >с {{ item.UF_ACTIVE_FROM }} по
                        {{ item.UF_ACTIVE_TO }}</span
                      >
                    </div>
                  </template>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="butt-stl butt-black"
                  @click="showStatusHistory = false"
                >
                  закрыть
                </button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </form>
      </div>
      <!-- /.modal -->
      <!-- История изменений статуса заявки -->
      <!--      /История изменения статуса модальное окно          -->
      <!--      URL компании модальное окно          -->
      <!-- Web сайт -->
      <div
        class="modal fade in show"
        v-if="isShowChangeWebSite"
        tabindex="-1"
        role="dialog"
      >
        <div class="modal-dialog modal-new-style" role="document">
          <div class="modal-content modal-content-middle">
            <div class="modal-header">
              <button type="button" class="close" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Web сайт</h4>
            </div>
            <div class="modal-body">
              <form style="margin-top: 0;">
                <div class="form-group">
                  <label for="i-pi-site">Web сайт</label>
                  <input
                    v-model="site"
                    id="i-pi-site"
                    type="text"
                    class="form-control"
                    placeholder="Укажите ссылку на сайт организации"
                  />
                </div>
              </form>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="butt-stl butt-black"
                data-dismiss="modal"
                @click="isShowChangeWebSite = false"
              >
                отменить
              </button>
              <button
                type="button"
                class="butt-stl butt-blue"
                @click="updateSite()"
              >
                Сохранить
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <!-- Web сайт -->
      <!--      /URL компании модальное окно          -->
      <!--      Добавление адреса модальное окно          -->
      <!-- Добавление адреса -->
      <div
        class="modal fade in show"
        v-if="showAdressDialog"
        tabindex="-1"
        role="dialog"
      >
        <form action="#">
          <div
            class="modal-dialog modal-close-active modal-new-style"
            role="document"
          >
            <div class="modal-content">
              <div class="modal-header">
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="showAdressDialog = false"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">Адрес организации</h4>
                <div class="modal-suptitle">
                  {{
                    modeEditAdress == "add" ? "Добавление" : "Редактирование"
                  }}
                  адреса
                </div>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <label for="i-type-address">Тип адреса</label>
                  <select
                    class="form-control"
                    v-model="address.UF_TYPE_ADDR_ID"
                    id="i-type-address"
                  >
                    <template v-if="modeEditAdress == 'add'">
                      <option
                        v-for="item in Object.values(
                          aboutProject.ORG_INFO.ADRESS_TYPE
                        )"
                        :key="item.ID"
                        :value="item.ID"
                      >
                        {{ item.NAME }}
                      </option>
                    </template>
                    <template v-else>
                      <option
                        v-for="item in Object.values(
                          aboutProject.ORG_INFO.ADRESS_ALL_TYPE
                        )"
                        :key="item.ID"
                        :value="item.ID"
                      >
                        {{ item.NAME }}
                      </option>
                    </template>
                  </select>
                </div>

                <div
                  class="form-group"
                  :class="{
                    'has-error': checkAddressErrorField('UF_POST_INDEX')
                  }"
                >
                  <label for="i-pi">Почтовый индекс</label>
                  <input
                    type="text"
                    id="i-pi"
                    v-model="address.UF_POST_INDEX"
                    class="form-control"
                    placeholder="Почтовый индекс"
                  />
                  <div class="error-text">
                    {{ checkAddressErrorField("UF_POST_INDEX") }}
                  </div>
                </div>
                <div
                  class="form-group"
                  :class="{
                    'has-error': checkAddressErrorField('UF_REGION_ID')
                  }"
                >
                  <label for="i-reg">Регион</label>
                  <select
                    class="form-control"
                    v-model="address.UF_REGION_ID"
                    id="i-reg"
                    placeholder="Регион"
                  >
                    <option
                      v-for="item in directory.regions"
                      :key="item.ID"
                      :value="item.ID"
                    >
                      {{ item.NAME }}
                    </option>
                  </select>
                  <div class="error-text">
                    {{ checkAddressErrorField("UF_REGION_ID") }}
                  </div>
                </div>
                <div
                  class="form-group"
                  :class="{ 'has-error': checkAddressErrorField('UF_CITY') }"
                >
                  <label for="i-np">Населенный пункт</label>
                  <input
                    type="text"
                    id="i-np"
                    v-model="address.UF_CITY"
                    class="form-control"
                    placeholder="Населенный пункт"
                  />
                  <div class="error-text">
                    {{ checkAddressErrorField("UF_CITY") }}
                  </div>
                </div>
                <div
                  class="form-group"
                  :class="{ 'has-error': checkAddressErrorField('UF_STREET') }"
                >
                  <label for="i-str">Улица</label>
                  <input
                    type="text"
                    id="i-str"
                    v-model="address.UF_STREET"
                    class="form-control"
                    placeholder="Улица"
                  />
                  <div class="error-text">
                    {{ checkAddressErrorField("UF_STREET") }}
                  </div>
                </div>
                <div
                  class="form-group"
                  :class="{ 'has-error': checkAddressErrorField('UF_HOME') }"
                >
                  <label for="i-dks">Дом, корпус, строение</label>
                  <input
                    type="text"
                    id="i-dks"
                    v-model="address.UF_HOME"
                    class="form-control"
                    placeholder="Дом, корпус, строение"
                  />
                  <div class="error-text">
                    {{ checkAddressErrorField("UF_HOME") }}
                  </div>
                </div>
                <div
                  class="form-group"
                  :class="{
                    'has-error': checkAddressErrorField('UF_OFFICE_NUMBER')
                  }"
                >
                  <label for="i-noffice">Номер офиса</label>
                  <input
                    type="text"
                    id="i-noffice"
                    v-model="address.UF_OFFICE_NUMBER"
                    class="form-control"
                    placeholder="Номер офиса"
                  />
                  <div class="error-text">
                    {{ checkAddressErrorField("UF_OFFICE_NUMBER") }}
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="butt-stl
                  butt-red"
                  v-if="modeEditAdress === 'edit'"
                  @click="deleteFactAddress(address.ID)"
                >
                  Удалить
                </button>
                <button
                  type="button"
                  @click="showAdressDialog = false"
                  class="butt-stl butt-black"
                  data-dismiss="modal"
                >
                  отменить
                </button>
                <button
                  type="button"
                  @click="saveAddress()"
                  class="butt-stl butt-blue"
                >
                  {{ modeEditAdress === "add" ? "Добавить" : "Сохранить" }}
                </button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </form>
      </div>
      <!-- /.modal -->
      <!-- Добавление адреса -->
      <!--      /Добавление адреса модальное окно          -->
      <!--      Менеджеры фонда модальное окно          -->
      <!-- Менеджеры фонда -->
      <div
        class="modal fade in show"
        v-if="showContactInformationModal"
        tabindex="-1"
        role="dialog"
      >
        <form v-if="aboutProject && aboutProject.CONTACT_FOND_INFO">
          <div class="modal-dialog modal-new-style" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">Менеджеры фонда</h4>
              </div>
              <div class="modal-body">
                <div
                  class="form-group"
                  v-for="(item, index) in aboutProject.CONTACT_FOND_INFO.LIST"
                  :key="index"
                >
                  <div v-if="item.IS_EDIT === 1">
                    <label :for="item.LABEL">{{ item.LABEL }}</label>
                    <select
                      class="form-control"
                      v-model="addManagerForm[item.FIELD]"
                      :id="item.FIELD"
                    >
                      <option
                        v-for="element in item.MANAGER_LIST"
                        :key="element.ID"
                        :value="element.ID"
                      >
                        {{ element.NAME }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  class="butt-stl butt-black"
                  type="button"
                  @click="showContactInformationModal = false"
                >
                  отменить
                </button>
                <button
                  class="butt-stl butt-blue"
                  type="button"
                  @click="saveManager()"
                >
                  Сохранить
                </button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </form>
      </div>
      <!-- /.modal -->
      <!-- Менеджеры фонда -->
      <!--      /Менеджеры фонда модальное окно          -->

      <!-- Откатить на КЭ -->
      <div
        class="modal fade in"
        tabindex="-1"
        v-bind:class="{ show: isViewDialogReturnCE }"
        role="dialog"
      >
        <form>
          <div class="modal-dialog modal-new-style" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">Вернуть проект на КЭ?</h4>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <p>
                    Вы действительно хотите вернуть проект на статус
                    "Комплексная экспертиза"?
                  </p>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  v-on:click="returnStatusKE()"
                  class="butt-stl butt-green"
                >
                  Вернуть на КЭ
                </button>

                <button
                  type="button"
                  class="butt-stl butt-black"
                  data-dismiss="modal"
                  v-on:click="isViewDialogReturnCE = false"
                >
                  отменить
                </button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </form>
      </div>
      <!-- /.modal -->
      <!-- Откатить на КЭ -->

      <!-- Добавление паузы -->
      <div
        class="modal fade in show"
        v-if="showPauseDialog"
        tabindex="-1"
        role="dialog"
      >
        <form action="#" @submit.prevent="submitPause">
          <div
            class="modal-dialog modal-close-active modal-dialog-datepicker-right_project modal-new-style"
            style="width: 520px;"
            role="document"
          >
            <div class="modal-content">
              <div class="modal-header">
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="showPauseDialog = false"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">Взять паузу для КЭ</h4>
              </div>
              <div class="modal-body">
                <div
                  class="form-group"
                  :class="{
                    'has-error': checkPauseErrorField('UF_ACTIVE_FROM')
                  }"
                >
                  <label for="i-type-address">Дата начала паузы</label>
                  <datepicker
                    v-model="pause.UF_ACTIVE_FROM"
                    :language="ru"
                    input-class="form-control filter-input-datapicer"
                    :monday-first="true"
                    @input="deletePauseErrorField('UF_ACTIVE_FROM')"
                    placeholder="Дата начала паузы"
                  />

                  <div class="error-text">
                    {{ checkPauseErrorField("UF_ACTIVE_FROM") }}
                  </div>
                </div>
                <div
                  class="form-group"
                  :class="{
                    'has-error': checkPauseErrorField('UF_ACTIVE_FROM')
                  }"
                >
                  <label for="i-type-address">Дата окончания паузы</label>
                  <datepicker
                    v-model="pause.UF_ACTIVE_TO"
                    :language="ru"
                    input-class="form-control filter-input-datapicer"
                    :monday-first="true"
                    @input="deletePauseErrorField('UF_ACTIVE_TO')"
                    placeholder="Дата окончания паузы"
                  />
                  <div class="error-text">
                    {{ checkPauseErrorField("UF_ACTIVE_TO") }}
                  </div>
                </div>

                <div
                  class="file-upload"
                  style="padding-top: 20px;"
                  :class="{
                    'has-error': checkPauseErrorField('UF_FILE_ID')
                  }"
                >
                  <div class="file-upload-label">
                    <table>
                      <tr>
                        <td>Файл официального письма:</td>
                        <td style="padding-left: 10px;">
                          <input
                            class="upload-file-area__input"
                            type="file"
                            name="file"
                            id="inp-file-expert-doc"
                            ref="file"
                            @change="changeFilePause"
                          />
                          <label
                            for="inp-file-expert-doc"
                            class="upload-file-area__label  butt-stl butt-blue"
                            style="text-transform: none;"
                            v-if="fileName"
                          >
                            <span class="upload-file-area__text">
                              <span v-text="fileName"></span>
                            </span>
                          </label>
                        </td>
                      </tr>
                    </table>

                    <div class="error-text">
                      {{ checkPauseErrorField("FILE") }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  @click="showPauseDialog = false"
                  class="butt-stl butt-black"
                  data-dismiss="modal"
                >
                  закрыть
                </button>
                <button
                  type="submit"
                  class="butt-stl butt-blue"
                  :disabled="uploadBlockButtonPause"
                >
                  Сохранить
                </button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </form>
      </div>
      <!-- /.modal -->
      <!-- Добавление адреса -->

      <!-- История постановки на паузы -->
      <div
        class="modal fade in show"
        v-if="showPauseHistory"
        tabindex="-1"
        role="dialog"
      >
        <div
          class="modal-dialog modal-close-active modal-new-style"
          role="document"
        >
          <div class="modal-content modal-content-middle modal-content-history">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                @click="showPauseHistory = false"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Паузы на КЭ</h4>
              <div class="modal-suptitle">
                {{ aboutProject.ORG_INFO.UF_NAME }} №
                {{ aboutProject.REQUEST_INFO.UF_NUMBER }}
              </div>
            </div>
            <div class="modal-body">
              <div
                class="modal-history-statys"
                v-for="(item, index) in aboutProject.REQUEST_INFO
                  .PAUSE_HISTORY_LIST"
                :key="index"
              >
                <div style="float: right;">
                  <div
                    v-if="item.UF_IS_CLOSE == 1"
                    class="modal-history-statys__author"
                    style="padding-top: 14px;"
                  >
                    Завершена {{ item.UF_DATE_CLOSE }}
                  </div>
                  <a
                    v-else
                    class="icon-item icon-delete-link"
                    @click="deletePause(item)"
                  ></a>
                </div>

                <div class="modal-history-statys__name">
                  с {{ item.UF_ACTIVE_FROM }} по {{ item.UF_ACTIVE_TO }}
                </div>
                <div class="modal-history-statys__author">
                  {{ item.UF_CREATED_BY_INFO }}
                  <span>{{ item.UF_DATE_CREATE }}</span>
                </div>
                <div class="modal-history-link">
                  <a :href="item.UF_FILE_LINK" target="_blank">
                    {{ item.UF_FILE_TEXT_LINK }}
                  </a>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button
                type="button"
                class="butt-stl butt-black"
                @click="showPauseHistory = false"
              >
                закрыть
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <!-- История  постановки на паузы  -->

      <!-- Изменение полей настроек проекта -->
      <div
        class="modal fade in show"
        v-if="showEditBoolSettingFields"
        tabindex="-1"
        role="dialog"
      >
        <form>
          <div class="modal-dialog modal-new-style" role="document">
            <div class="modal-content modal-content-middle">
              <div class="modal-header">
                <button type="button" class="close" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">Изменение настроек проекта</h4>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <label>{{ labelSettingFiled }}</label>
                  <select
                    class="form-control"
                    v-model="valueTempBoolSettingFields"
                    :id="nameSettingField"
                  >
                    <option value="0">Нет</option>
                    <option value="1">Да</option>
                  </select>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  class="butt-stl butt-black"
                  type="button"
                  @click="showEditBoolSettingFields = false"
                >
                  отменить
                </button>
                <button
                  class="butt-stl butt-blue"
                  type="button"
                  @click="saveEditSettingField()"
                >
                  Изменить
                </button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </form>
      </div>
      <!-- /.modal -->
      <!-- Изменение полей настроек проекта -->

    </div>
  </div>
</template>

<script>
import Inputmask from "inputmask";
import { mapGetters } from "vuex";
import {
  FETCH_DIRECTORIES,
  FETCH_PROJECT_HISTORY,
  SET_IS_VIEW_ALL_EXPERTISE,
  FETCH_ABOUT_PROJECT,
  FETCH_PROJECT
} from "@/store/actions.type";
import Contacts from "./lists/contacts";
import { ProjectsService } from "@/common/api.service";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import { ru } from "vuejs-datepicker/dist/locale";
import vueDropzone from "vue2-dropzone";
import { AUTH_URL } from "@/common/config";
import FirstScenariosStep from "@/components/project/form/subpartial/FirstScenariosStep.vue";
import ChangeStatusDialog from "@/components/project/form/ChangeStatusDialog";
import AddInfo from "@/components/project/AddInfo.vue";
import Requests from "@/components/requests/List.vue";
import { Dropdown as VDropdown } from "floating-vue";
import BudgetOld from "./partial/BudgetOld.vue";
import Multiselect from "vue-multiselect";
import ProjectOkpdProducts from "@/components/project/form/partial/ProjectOkpdProducts";

export default {
  name: "step1",
  components: {
    Multiselect,
    BudgetOld,
    FirstScenariosStep,
    Contacts,
    vueDropzone,
    Datepicker,
    ChangeStatusDialog,
    VDropdown,
    ProjectOkpdProducts
  },
  props: ["step", "isAccept"],
  data() {
    return {
      showChangeStatusDialog: false,
      showStatusHistory: false,
      isShowChangeWebSite: false,
      showContactInformationModal: false,
      titleContactChange: "Создание контакта",
      isShowContacts: true,
      isShowAssociatedOrgs: true,
      isShowHistoryES: true,
      isShowApplication: true,
      isShowContactsInfo: true,
      isShowAcceptInfo: true,
      lizing: {
        UF_NAME: "",
        UF_OGRN: ""
      },
      addManagerForm: {},
      lizingErrors: [],
      contactTextError: "",
      isEditContacts: false,
      isEditContactsRfpr: false,
      addFileDocError: "",
      addFileSnilsError: "",
      showSnilsUploader: false,
      snilsFile: "",
      snilsFileName: "",
      snilsFileError: "",
      showAdressDialog: false,
      addressIndex: 0,
      showSiteDialog: false,
      showEditContact: false,
      site: "",
      address: {
        ID: 0,
        UF_CITY: "",
        UF_COMPANY_ID: 0,
        UF_HOME: 0,
        UF_OFFICE_NUMBER: 0,
        UF_POST_INDEX: 0,
        UF_REGION_ID: 0,
        UF_STREET: "",
        UF_TYPE_ADDR_ID: 0
      },
      addressErrors: [],
      contact: {},
      contactIndex: 0,
      contactErrors: [],
      contactTp: "CONTACTS",
      showDocContactUploader: false,
      docName: "",
      docId: 0,
      contactDoc: {
        UF_TRUST_FILE: "",
        UF_TRUST_DATE_END: "",
        UF_SNILS: ""
      },
      stConf: {},
      contactDocErrors: [],
      snilsErrors: [],
      acceptAvailable: false,
      ru: ru,
      modeEditAdress: "add",
      isViewDialogReturnCE: false,
      showPauseDialog: false,
      pauseErrors: [],
      pause: {
        UF_ACTIVE_FROM: "",
        UF_ACTIVE_TO: "",
        FILE: ""
      },
      file: "",
      fileName: "Выберите файл",
      fileName2: "",
      uploadBlockButtonPause: false,
      showPauseHistory: false,
      showEditBoolSettingFields: false,
      valueTempBoolSettingFields: 0,
      nameSettingField: "",
      labelSettingFiled: "",
      isViewAcceptPlan: 0
    };
  },

  mounted() {
    this.fetchAboutProject().then(() => {
      this.aboutProject.CONTACT_FOND_INFO.LIST.forEach(item => {
        if (item.IS_EDIT == 1) {
          this.addManagerForm[item.FIELD] = item.VALUE;
        }
      });
    });
    this.$store.dispatch(FETCH_PROJECT, this.$route.params.id);
    this.isEditContacts = this.currentUser.ACTIVE_ROLE_CODE !== "manager3";
    if (this.currentUser.ACTIVE_ROLE_CODE === "region_fond") {
      this.isEditContactsRfpr = true;
    }
    this.$store.dispatch(FETCH_DIRECTORIES, [
      "regions",
      "org_form",
      "type_address"
    ]);

    ProjectsService.getManagerRoleDefaultSetting().then(({ data }) => {
      this.$store.dispatch(
        SET_IS_VIEW_ALL_EXPERTISE,
        data.IS_VIEW_ALL_EXPERTISE
      );

      if (data.IS_ACCEPT_TRUST) {
        this.acceptAvailable = true;
      }

      this.isViewAcceptPlan =
        parseInt(data.IS_ACCEPT_PLAN) &&
        this.aboutProject.PROJECT_MAIN_INFO.IS_VIEW_DOC_ES
          ? 1
          : 0;
    }, this);

    this.getLinkRequest();
  },
  computed: {
    Requests() {
      return Requests;
    },
    AddInfo() {
      return AddInfo;
    },
    regYears() {
      let dt = new Date();
      let years = [];
      for (let i = dt.getFullYear(); i >= 1991; i--) {
        years.push(i);
      }
      return years;
    },

    ...mapGetters([
      "directory",
      "currentUser",
      "aboutProject",
      "projectStatusHistory",
      "project"
    ])
  },
  methods: {
    async fetchAboutProject() {
      await this.$store.dispatch(FETCH_ABOUT_PROJECT, this.$route.params.id);
    },
    handleToRequest() {
      if (this.aboutProject.IS_REDIRECT_SCENARIO_URL) {
        this.$router.push({
          name: "ScenarioRequest",
          params: { id: this.$route.params.id }
        });
      } else {
        this.$emit("set", "description");
      }
    },
    saveManager() {
      ProjectsService.addManager(
        this.$route.params.id,
        this.addManagerForm
      ).then(({ data }) => {
        if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
          return;
        } else {
          this.$toasted.show(
            "Информация по менеджерам Фонда успешно изменена",
            {
              theme: "green",
              position: "bottom-right",
              duration: 3000
            }
          );

          //this.addManagerForm = {};
          this.showContactInformationModal = false;
          this.fetchAboutProject();

          /*this.aboutProject.CONTACT_FOND_INFO.LIST.forEach(item => {
            if (item.IS_EDIT == 1) {
              this.addManagerForm[item.FIELD] = item.VALUE;
            }
          });*/
        }
      }, this);
    },
    saveManagerOne(field) {
      this.addManagerForm = {};
      this.addManagerForm[field] =
        this.currentUser.ID > 0 ? this.currentUser.ID : 1;
      ProjectsService.addManager(
        this.$route.params.id,
        this.addManagerForm
      ).then(({ data }) => {
        if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
          return;
        } else {
          this.$toasted.show("Информация успешно изменена", {
            theme: "green",
            position: "bottom-right",
            duration: 3000
          });
        }

        this.addManagerForm = {};
        this.fetchAboutProject();

        this.aboutProject.CONTACT_FOND_INFO.LIST.forEach(item => {
          if (item.IS_EDIT == 1) {
            this.addManagerForm[item.FIELD] = item.VALUE;
          }
        });
      }, this);
    },
    getNameApplicationTZ() {
      let nameApplicationTZ = "Техническое задание";
      if (this.getProgramCode() === "lizing") {
        nameApplicationTZ = "Спецификация на промышленное оборудование";
      } else if (this.getProgramCode() === "component_and_resource_base") {
        nameApplicationTZ = "Основные характеристики проекта";
      }

      return nameApplicationTZ;
    },
    // методы для блока Приложения
    getPrintTZDocxUrl() {
      ProjectsService.getPrintTZDocxUrl(this.$route.params.id).then(
        ({ data }) => {
          window.location.href =
            AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
        }
      );
    },
    getPrintBudgetDocxUrl() {
      ProjectsService.getPrintBudgetDocxUrl(this.$route.params.id).then(
        ({ data }) => {
          window.location.href =
            AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
        }
      );
    },
    getPrintPlanDocxUrl() {
      ProjectsService.getPrintPlanDocxUrl(this.$route.params.id).then(
        ({ data }) => {
          window.location.href =
            AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
        }
      );
    },
    getPrintIndicatorsDocxUrl() {
      ProjectsService.getPrintIndicatorsDocxUrl(this.$route.params.id).then(
        ({ data }) => {
          window.location.href =
            AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
        }
      );
    },
    // окончание методов для блока Приложения
    // методы для блока Информация о проекте
    getLinkFileArhiveDZ() {
      ProjectsService.getLinkFileArhiveDZ(this.$route.params.id).then(
        ({ data }) => {
          window.location.href =
            AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
        }
      );
    },
    getLinkPdfUrl() {
      ProjectsService.getPrintPDFUrl(this.$route.params.id).then(({ data }) => {
        window.open(
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link,
          "_blank"
        );
      });
    },
    getLinkFileArhive() {
      ProjectsService.getLinkFileArhive(this.$route.params.id).then(
        ({ data }) => {
          window.location.href =
            AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
        }
      );
    },
    // окончание методов для блока Информация о проекте
    // методы для добавления/редактирования адрессов
    editAddress(index) {
      this.addressErrors = [];
      this.addressIndex = index;
      this.modeEditAdress = "edit";
      this.address = JSON.parse(
        JSON.stringify(this.aboutProject.ORG_INFO.ADRESS[this.addressIndex])
      );
      this.showAdressDialog = true;
    },
    getLinkRequest() {
     /* let string =
        '/requests?filter={"project_number"%3A"' +
        this.aboutProject.REQUEST_INFO.UF_NUMBER +
        '","number"%3A"","status"%3A[],"initiator"%3A"","organization"%3A"","performer"%3A""}';*/

      let string =
        '/requests?filter=' + JSON.stringify({
          project_number: this.aboutProject.REQUEST_INFO.UF_NUMBER,
          number:[],
          status: [],
          initiator: [],
          organization: [],
          performer: ""
        });

      return string;
    },
    getLinkRequestCreate() {
      let string =
        '/requests?action=create&idProject=' + this.aboutProject.project.ID;
      return string;
    },
    deleteFactAddress(idAddress) {
      if (confirm("Вы уверены, что хотите удалить адрес?")) {
        ProjectsService.deleteAddress(
          this.aboutProject.ORG_INFO.ID,
          idAddress
        ).then(({ data }) => {
          if (data.error.length) {
            data.error.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }, this);
            return;
          } else {
            this.$toasted.show("Адрес организации успешно удален", {
              theme: "green",
              position: "bottom-right",
              duration: 3000
            });

            this.fetchAboutProject();
            this.showAdressDialog = false;
          }
        }, this);
      }
    },
    makeAddress(type) {
      this.modeEditAdress = "add";
      this.addressErrors = [];
      this.addressIndex = -1;
      this.address = {
        UF_CITY: "",
        UF_COMPANY_ID: 0,
        UF_HOME: "",
        UF_OFFICE_NUMBER: "",
        UF_POST_INDEX: "",
        UF_REGION_ID: 0,
        UF_STREET: "",
        UF_TYPE_ADDR_ID: type
      };
      this.showAdressDialog = true;
    },
    makePause() {
      this.pauseErrors = [];
      this.pause = {
        UF_ACTIVE_FROM: "",
        UF_ACTIVE_TO: "",
        FILE: ""
      };
      this.fileName = "Выберите файл";
      this.uploadBlockButtonPause = false;
      this.showPauseDialog = true;
    },
    changeFilePause() {
      let reader = new FileReader();
      (this.errorText = ""), reader.readAsDataURL(this.$refs.file.files[0]);
      reader.onload = () => {
        let file = this.$refs.file.files[0];
        if (file.size < 1024 * 1024 * 100) {
          let header = ";base64,";
          let fileData = reader.result;

          this.fileBase64 = fileData.substr(
            fileData.indexOf(header) + header.length
          );

          this.deletePauseErrorField("FILE");
        } else {
          this.errorText =
            "Загружаемый файл превышает максимально разрешенный размер. Загрузить можно файл размером не более 100 Мб";
        }
      };
      this.fileName = this.$refs.file.files[0].name;
    },
    submitPause() {
      this.uploadBlockButtonPause = true; //блокировка кнопки

      /*if (typeof this.$refs.file.files[0] === "undefined") {
        this.uploadBlockButtonPause = false;
        this.$toasted.show("Загрузите файл официального письма", {
          theme: "red",
          position: "bottom-right",
          duration: 3000
        });
        return false;
      }*/

      let formData = new FormData();

      if (this.pause.UF_ACTIVE_FROM != "") {
        formData.append(
          "UF_ACTIVE_FROM",
          moment(this.pause.UF_ACTIVE_FROM).format("DD.MM.YYYY")
        );
      }

      if (this.pause.UF_ACTIVE_TO != "") {
        formData.append(
          "UF_ACTIVE_TO",
          moment(this.pause.UF_ACTIVE_TO).format("DD.MM.YYYY")
        );
      }
      if (typeof this.$refs.file.files[0] === "undefined") {
        formData.append("FILE", "");
      } else {
        formData.append("FILE", this.$refs.file.files[0]);
      }

      ProjectsService.addPause(
        this.$route.params.id,
        formData,
        this.pause
      ).then(response => {
        if (!response.data.error) {
          this.fetchAboutProject();
          this.showPauseDialog = false;
          this.$toasted.show("Пауза успешно добавлена в проект", {
            theme: "green",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          this.pauseErrors = response.data.errorArr;
          this.uploadBlockButtonPause = false;
        }
      }, this);
      return false;
    },
    deletePause(item) {
      ProjectsService.deletePause(this.$route.params.id, item.ID).then(
        response => {
          if (!response.data.error) {
            this.fetchAboutProject();
            this.$toasted.show("Пауза успешно удалена из проекта", {
              theme: "green",
              position: "bottom-right",
              duration: 3500
            });
          } else {
            response.data.errorArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }, this);
          }
        },
        this
      );
    },
    saveAddress() {
      if (!this.aboutProject.ORG_INFO.ADRESS) {
        this.aboutProject.ORG_INFO.ADRESS = [];
      }
      if (this.addressIndex !== -1) {
        ProjectsService.editAddress(
          this.aboutProject.ORG_INFO.ID,
          this.address.UF_TYPE_ADDR_ID,
          this.address
        )
          .then(({ data }) => {
            if (data.error) {
              this.addressErrors = data.errorAr;
              return;
            }
            this.showAdressDialog = false;
            this.address = {
              ID: 0,
              UF_CITY: "",
              UF_COMPANY_ID: 0,
              UF_HOME: 0,
              UF_OFFICE_NUMBER: 0,
              UF_POST_INDEX: 0,
              UF_REGION_ID: 0,
              UF_STREET: "",
              UF_TYPE_ADDR_ID: 0
            };
            this.fetchAboutProject();

            this.$toasted.show(
              "Информация по адресу организации успешно изменена",
              {
                theme: "green",
                position: "bottom-right",
                duration: 3000
              }
            );
          }, this)
          .catch(data => {
            console.log(data);
          });
      } else {
        ProjectsService.addAddress(
          this.aboutProject.ORG_INFO.ID,
          this.address.UF_TYPE_ADDR_ID,
          this.address
        ).then(({ data }) => {
          if (data.error) {
            this.addressErrors = data.errorAr;
            return;
          }
          this.showAdressDialog = false;
          this.address = {
            ID: 0,
            UF_CITY: "",
            UF_COMPANY_ID: 0,
            UF_HOME: 0,
            UF_OFFICE_NUMBER: 0,
            UF_POST_INDEX: 0,
            UF_REGION_ID: 0,
            UF_STREET: "",
            UF_TYPE_ADDR_ID: 0
          };
          this.fetchAboutProject();

          this.$toasted.show("Адрес организации успешно добавлен", {
            theme: "green",
            position: "bottom-right",
            duration: 3000
          });
        }, this);
      }
    },
    checkAddressErrorField(field) {
      let t = this.addressErrors.filter(c => c.FIELDS === field);
      if (t.length > 0) {
        return t[0].TEXT;
      }
      return "";
    },
    // окончание методов для добавления/редактирования адрессов
    checkPauseErrorField(field) {
      let t = this.pauseErrors.filter(c => c.FIELDS === field);
      if (t.length > 0) {
        return t[0].TEXT;
      }
      return "";
    },
    deletePauseErrorField(field) {
      let t = this.pauseErrors.filter(c => c.FIELDS === field);
      if (t.length > 0) {
        t[0].TEXT = "";
      }
      return "";
    },
    // методы для добавления/редактирования веб сайта
    makeSiteDialog() {
      this.site = this.aboutProject.ORG_INFO.UF_WEB_SITE;
      this.isShowChangeWebSite = true;
    },
    updateSite() {
      ProjectsService.editWebSite(this.aboutProject.ORG_INFO.ID, {
        UF_WEB_SITE: this.site
      })
        .then(({ data }) => {
          if (data.error) {
            return;
          }
          this.isShowChangeWebSite = false;
          this.fetchAboutProject();

          this.$toasted.show(
            "Информация о web-сайте организации успешно изменена",
            {
              theme: "green",
              position: "bottom-right",
              duration: 3000
            }
          );
        }, this)
        .catch(data => {
          console.log(data);
        });
    },
    // окончание методов для добавления/редактирования веб сайта
    loadStatusHistory() {
      this.$store.dispatch(FETCH_PROJECT_HISTORY).then(() => {
        this.showStatusHistory = true;
      });
    },
    loadPauseHistory() {
      this.showPauseHistory = true;
    },
    showEditFieldSettingBoolProject(value, field, label) {
      this.showEditBoolSettingFields = true;
      this.valueTempBoolSettingFields = value;
      console.log(this.valueTempBoolSettingFields);
      this.nameSettingField = field;
      this.labelSettingFiled = label;
    },
    getStatusName: function(id) {
      let t = this.directory.status_all.filter(c => c.ID === id);
      if (t.length > 0) {
        return t[0].NAME;
      }
    },
    addOrgLizing() {
      this.lizingErrors = [];
      ProjectsService.addOrgLizing(this.$route.params.id, this.lizing).then(
        ({ data }) => {
          if (data.error) {
            this.lizingErrors = data.errorAr;
            return;
          }
          this.aboutProject.ORG_INFO = data.ORG_INFO;
          this.fetchAboutProject();
        },
        this
      );
    },
    clearCache() {
      ProjectsService.clearCache(this.$route.params.id).then(({ data }) => {
        if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
          return;
        } else {
          this.$toasted.show("Кэш проекта успешно сброшен", {
            theme: "green",
            position: "bottom-right",
            duration: 3500
          });
        }
        this.fetchAboutProject();
      }, this);
    },
    getShablonTrust() {
      ProjectsService.getShablonTrust().then(({ data }) => {
        window.open(
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link,
          "_blank"
        );
      });
    },
    updateContactAccept(index, ac) {
      ProjectsService.saveAcceptContact(
        this.aboutProject.project.ID,
        this.aboutProject.CONTACTS[index].ID,
        {
          UF_TRUST_IS_ACCEPT: ac
        }
      ).then(({ data }) => {
        if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
          return;
        }
        this.aboutProject.CONTACTS[index].UF_TRUST_IS_ACCEPT = ac;
      }, this);
    },
    dateFormat(date) {
      return moment(date).format("DD.MM.YYYY");
    },
    makeContact(tp) {
      this.contactTp = tp;
      this.contactIndex = -1;
      this.contact = {
        ID: 0,
        UF_COMPANY_ID: this.aboutProject.ORG_INFO.ID,
        UF_EMAIL1: "",
        UF_EMAIL2: "",
        UF_FIRST_NAME: "",
        UF_IS_LIZING_ADD: 0,
        UF_IS_LIZING_CONTACT: 0,
        UF_IS_REG_F_CONTACT: 0,
        UF_NAME: "",
        UF_PHONE1: "",
        UF_PHONE2: "",
        UF_POSITION: "",
        UF_PROJECT_ID: this.$route.params.id,
        UF_SECOND_NAME: "",
        UF_SNILS: null,
        UF_TRUST_DATE_ACEPT: null,
        UF_TRUST_DATE_END: null,
        UF_TRUST_FILE: null,
        UF_TRUST_IS_ACCEPT: null
      };
      this.showEditContact = true;
      this.contactTextError = "";
      this.titleContactChange = "Создание контакта ";
      this.contactMask();
    },
    contactMask() {
      var im = new Inputmask({
        mask: "*{1,20}[.*{1,20}][.*{1,20}][.*{1,20}]@*{1,20}[.*{2,6}][.*{1,2}]",
        greedy: false,
        onBeforePaste: function(pastedValue) {
          pastedValue = pastedValue.toLowerCase();
          return pastedValue.replace("mailto:", "");
        },
        definitions: {
          "*": {
            validator: "[0-9A-Za-z!#$%&'*+/=?^_`{|}~-]",
            casing: "lower"
          }
        }
      });
      im.mask(this.$refs.aemailfield);
      im.mask(this.$refs.bemailfield);

      var phonemask = new Inputmask({
        mask: "+7 (999) 999-99-99",
        greedy: false,
        definitions: {
          "*": {
            validator: "[0-9-]",
            casing: "lower"
          }
        }
      });
      phonemask.mask(this.$refs.aphonefield);
      phonemask.mask(this.$refs.bphonefield);
    },
    saveContact() {
      if (!this.aboutProject[this.contactTp]) {
        this.aboutProject[this.contactTp] = [];
      }
      if (this.contactTp === "CONTACTS_LIZING") {
        this.contact["UF_IS_LIZING_CONTACT"] = 1;
      } else {
        this.contact["UF_IS_LIZING_CONTACT"] = 0;
      }
      this.contactTextError = "";
      if (this.contactIndex !== -1) {
        ProjectsService.editContacts(
          this.aboutProject.ORG_INFO.ID,
          this.aboutProject.project.ID,
          this.contact
        )
          .then(({ data }) => {
            if (data.error) {
              this.contactErrors = data.errorAr;
              return;
            }
            this.showEditContact = false;
            this.aboutProject[this.contactTp][this.contactIndex] = JSON.parse(
              JSON.stringify(this.contact)
            );
          }, this)
          .catch(({ data }) => {
            if (data["text-error"]) {
              this.contactTextError = data["text-error"];
            }
          }, this);
      } else {
        ProjectsService.addContacts(
          this.aboutProject.ORG_INFO.ID,
          this.aboutProject.project.ID,
          this.contact
        )
          .then(({ data }) => {
            if (data.error) {
              this.contactErrors = data.errorAr;
              if (data["text-error"]) {
                this.contactTextError = data["text-error"];
              }
              return;
            }
            this.contact.ID = data.ID;
            this.showEditContact = false;
            this.aboutProject[this.contactTp].push(
              JSON.parse(JSON.stringify(this.contact))
            );
          }, this)
          .catch(({ data }) => {
            if (data["text-error"]) {
              this.contactTextError = data["text-error"];
            }
          }, this);
      }
    },
    deleteContact(contactId, contactIndex) {
      console.log(contactId);
      if (confirm("Вы уверены, что хотите удалить контакт?")) {
        ProjectsService.deleteContacts(
          this.aboutProject.ORG_INFO.ID,
          this.aboutProject.project.ID,
          contactId
        )
          .then(({ data }) => {
            if (data.error) {
              this.contactErrors = data.errorAr;
              return;
            }

            this.aboutProject[this.contactTp].splice(contactIndex, 1);
            this.showEditContact = false;
          }, this)
          .catch(err => console.log("deleteContactError: ", err.message));
      }
      this.showEditContact = false;
    },
    editContact(tp, index) {
      this.contactErrors = [];
      this.contactIndex = index;
      this.contactTp = tp;
      this.contact = JSON.parse(
        JSON.stringify(this.aboutProject[this.contactTp][this.contactIndex])
      );
      this.showEditContact = true;
      this.titleContactChange = "Редактирование контакта";
      this.contactMask();
    },
    uploadSnils() {
      ProjectsService.downloadFileSnils(this.aboutProject.ORG_INFO.ID, {
        UF_SNILS_FILE: this.snilsFile
      })
        .then(({ data }) => {
          if (data.error) {
            this.snilsErrors = data.errorAr;
            return;
          }
          this.fetchAboutProject();
          this.showSnilsUploader = false;
        }, this)
        .catch(data => {
          console.log(data);
        });
    },
    uploadDoc() {
      ProjectsService.downloadFileSnilsContact(
        this.aboutProject.ORG_INFO.ID,
        this.docId,
        this.contactDoc
      )
        .then(({ data }) => {
          if (data.error) {
            this.contactDocErrors = data.errorAr;
            return;
          }
          this.fetchAboutProject();
          this.showDocContactUploader = false;
        }, this)
        .catch(data => {
          console.log(data);
        });
    },
    snilsChange(file) {
      let f = this.$refs.snilsDR.dropzone.files;
      if (f.length > 1) {
        this.$refs.snilsDR.removeFile(f[0]);
      }
      this.snilsFileName = file.name;
      let reader = new FileReader();
      this.addFileSnilsError = "";
      reader.addEventListener("loadend", function() {});
      reader.readAsDataURL(file);

      reader.onload = () => {
        if (file.size < 1024 * 1024 * 25) {
          this.snilsFileName = file.name;
          this.snilsFile = reader.result;
        } else {
          this.snilsFileName = "";
          this.snilsFile = "";
          this.addFileSnilsError =
            "Загружаемый файл превышает максимально разрешенный размер. Загрузить можно файл размером не более 25 Мб";
        }
      };
    },
    docChange(file) {
      let f = this.$refs.docDR.dropzone.files;
      if (f.length > 1) {
        this.$refs.docDR.removeFile(f[0]);
      }
      this.docName = file.name;
      let reader = new FileReader();
      this.addFileDocError = "";
      reader.addEventListener("loadend", function() {});
      reader.readAsDataURL(file);

      reader.onload = () => {
        if (file.size < 1024 * 1024 * 25) {
          this.docName = file.name;
          this.contactDoc.UF_TRUST_FILE = reader.result;
        } else {
          this.docName = "";
          this.contactDoc.UF_TRUST_FILE = "";
          this.addFileDocError =
            "Загружаемый файл превышает максимально разрешенный размер. Загрузить можно файл размером не более 25 Мб";
        }
      };
    },
    checkContactErrorField(field) {
      let t = this.contactErrors.filter(c => c.FIELDS === field);
      if (t.length > 0) {
        return t[0].TEXT;
      }
      return "";
    },
    checkContactDocErrorField(field) {
      let t = this.contactDocErrors.filter(c => c.FIELDS === field);
      if (t.length > 0) {
        return t[0].TEXT;
      }
      return "";
    },
    uploadContactDoc(id) {
      this.docId = id;
      this.docName = "";
      this.contactDocErrors = [];
      this.contactDoc = {
        UF_TRUST_FILE: "",
        UF_TRUST_DATE_END: "",
        UF_SNILS: ""
      };
      this.showDocContactUploader = true;
    },
    openByReturnCE() {
      this.isViewDialogReturnCE = true;
    },
    returnStatusKE() {
      ProjectsService.setReturnStatusProjectCE(this.$route.params.id)
        .then(({ data }) => {
          if (data.error) {
            data.errorArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }, this);
            return;
          } else {
            this.fetchAboutProject();
            this.isViewDialogReturnCE = false;
          }
        }, this)
        .catch(data => {
          console.log(data);
        });
    },
    saveEditSettingField() {
      ProjectsService.editSettingProjectField(
        this.$route.params.id,
        this.nameSettingField,
        {
          VALUE: this.valueTempBoolSettingFields
        }
      ).then(({ data }) => {
        if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
          return;
        } else {
          this.$toasted.show(
            'Информация по полю "' +
              this.labelSettingFiled +
              '" успешно изменена',
            {
              theme: "green",
              position: "bottom-right",
              duration: 3000
            }
          );
        }

        this.showEditBoolSettingFields = false;
        this.fetchAboutProject();
      }, this);
    },
    changeAcceptProject(params) {
      ProjectsService.changeAcceptProject(this.$route.params.id, params).then(
        ({ data }) => {
          if (data.error) {
            data.errorArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }, this);
            return;
          } else {
            this.$toasted.show(
              "Статус акцепта резюме проекта успешно изменен",
              {
                theme: "green",
                position: "bottom-right",
                duration: 3000
              }
            );
            this.aboutProject.project.UF_IS_ACCEPT_PROJECT = params;
          }
        },
        this
      );
    },
    changeAcceptEquipment(params) {
      ProjectsService.changeAcceptEquipment(this.$route.params.id, params).then(
        ({ data }) => {
          if (data.error) {
            data.errorArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }, this);
            return;
          } else {
            this.$toasted.show(
              "Статус акцепта списка закупаемого успешно изменен",
              {
                theme: "green",
                position: "bottom-right",
                duration: 3000
              }
            );

            this.aboutProject.project.UF_SETTING.IS_EQUIPMENT_ACCEPT = params;
            console.log(this.aboutProject.project.UF_SETTING.IS_EQUIPMENT_ACCEPT);
          }
        },
        this
      );
    },
    changeAcceptCalendarPlan(params) {
      ProjectsService.changeAcceptCalendarPlan(
        this.$route.params.id,
        params
      ).then(({ data }) => {
        if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
          return;
        } else {
          this.$toasted.show(
            "Статус акцепта КП, задач, целей и продукции проекта успешно изменен",
            {
              theme: "green",
              position: "bottom-right",
              duration: 3000
            }
          );

          this.aboutProject.project.UF_SETTING.IS_PLAN_ACCEPT = params;
        }
      }, this);
    }
  }
};
</script>

<style scoped></style>
